import React from 'react';
import MenuWeekPicker from './MenuWeekPicker';
import TextAreaView from '../shared/TextAreaView';
import { maskLiveDate } from '../../masks';

class MenuWeeklyDetails extends React.Component {
  render() {
    const { isEdit, updateMenu, openModal } = this.props;
    const { service_week, notes } = this.props.menu;
    return (
      <div className="cms__content">
        <div className="row">
          <div className="row__item row__item--third">
            <div className="cms__section">
              <h3 className="h3 cms__section-head">Service Week</h3>
              <MenuWeekPicker
                isEdit={isEdit}
                updateMenu={updateMenu}
                value={service_week}
              />
            </div>
          </div>
          <div className="row__item row__item--third">
            <div className="cms__section">
              <h3 className="h3 cms__section-head">Going Live on</h3>
              <p className="p">{maskLiveDate(service_week)}</p>
            </div>
          </div>
          <div className="row__item row__item--third">
            <TextAreaView
              title="Private Notes"
              isEdit={isEdit}
              value={notes}
              openEdit={() => openModal('notes')}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default MenuWeeklyDetails;



// WEBPACK FOOTER //
// ./src/components/menu/MenuWeeklyDetails.js